import React from "react";
import { FaPaypal, FaUniversity } from "react-icons/fa";
import { SiStripe } from "react-icons/si";
import { Box, Grid, Typography, Link, Button } from "@mui/material";
import logo from "../../Assets/Images/BLU TAXI white logo.png";
import { paths } from "../../config/constants";
// import "./footer.css";  // assuming CSS defined below

const Footer = () => {
  return (
    <footer className="footer-container">
      {/* Top: Brand + CTA Buttons */}
      {/* Top: Brand Left + Buttons Right */}
<Box className="footer-top-cta footer-top-cta--row">
   <Link to={paths.home}>
                  <img src={logo} width="180" height="70" alt="Logo" />
                </Link>
  <Box className="footer-cta-buttons">
    <Button
      variant="contained"
      className="footer-btn footer-btn-register-company"
      href="/accounts/agent-register"
    >
     Company / Agent Registration
    </Button>
    <Button
      variant="contained"
      className="footer-btn footer-btn-register-carrier"
      href="/accounts/driver-carrier-registration"
    >
      Carrier Registration
    </Button>
  </Box>
</Box>


      {/* Separator line */}
      <Box className="footer-separator" />

      {/* Link Columns */}
      <Box className="footer-links-wrapper">
      <Box className="footer-links-group">
        <Grid container spacing={4}>
          {/* Column 1 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">Company</Typography>
            <ul>
              <li><Link href="#">How BLU.TAXI works</Link></li>
              <li><Link href="#">Careers</Link></li>
              <li><Link href="#">Press</Link></li>
              <li><Link href="#">Blog</Link></li>
              <li><Link href="#">Green initiatives</Link></li>
              <li><Link href="#">Become a Chauffeur Partner</Link></li>
              <li><Link href="#">Influencers</Link></li>
            </ul>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">BLU.TAXI for Business</Typography>
            <ul>
              <li><Link href="#">Overview</Link></li>
              <li><Link href="#">Corporations</Link></li>
              <li><Link href="#">Travel Agencies</Link></li>
              <li><Link href="#">Strategic Partnerships</Link></li>
            </ul>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">Top Cities</Typography>
            <ul>
              <li><Link href="#">New York</Link></li>
              <li><Link href="#">London</Link></li>
              <li><Link href="#">Berlin</Link></li>
              <li><Link href="#">Los Angeles</Link></li>
              <li><Link href="#">Paris</Link></li>
              <li><Link href="#">All cities</Link></li>
            </ul>
          </Grid>

          {/* Column 4 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">Explore</Typography>
            <ul>
              <li><Link href="#">City‑to‑City rides</Link></li>
              <li><Link href="#">Limousine Service</Link></li>
              <li><Link href="#">Chauffeur Service</Link></li>
              <li><Link href="#">Private Car Service</Link></li>
              <li><Link href="#">Ground Transportation</Link></li>
              <li><Link href="#">Airport Transfer</Link></li>
              <li><Link href="#">All countries</Link></li>
            </ul>
          </Grid>

          {/* Column 5 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">City‑to‑City Rides <span className="badge-new">NEW</span></Typography>
            <ul>
              <li><Link href="#">New York – East Hampton</Link></li>
              <li><Link href="#">Los Angeles – San Diego</Link></li>
              <li><Link href="#">Miami – Palm Beach</Link></li>
              <li><Link href="#">London – Bristol</Link></li>
              <li><Link href="#">Dubai – Abu Dhabi</Link></li>
              <li><Link href="#">Paris – Reims</Link></li>
            </ul>
          </Grid>
        </Grid>
      </Box>
      </Box>

      {/* Bottom bar: copyright etc */}
      {/* <Box className="footer-bottom-bar">
        <Typography variant="body2">© {new Date().getFullYear()} BLU.TAXI</Typography>
        <Box className="footer-bottom-links">
          <Link href="#">Terms</Link>
          <Link href="#">Privacy policy</Link>
          <Link href="#">Legal notice</Link>
          <Link href="#">Accessibility</Link>
        </Box>
      </Box> */}
      <Box className="footer-bottom-bar">
  {/* Left: Copyright */}
   <Box className="footer-bottom-left">
    <FaPaypal className="footer-payment-icon paypal" />
    <SiStripe className="footer-payment-icon stripe" />
    <FaUniversity className="footer-payment-icon bank" />
  </Box>
  <Box className="footer-bottom-right">
    <Typography variant="body2">© {new Date().getFullYear()} BLU.TAXI</Typography>
        <Box className="footer-bottom-links">
          <Link href="#">Terms</Link>
          <Link href="#">Privacy policy</Link>
          <Link href="#">Legal notice</Link>
          <Link href="#">Accessibility</Link>
        </Box>
  </Box>

 
</Box>
    </footer>
  );
};

export default Footer;
